import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { Printer } from "~/providers/printing-provider";
import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { usePrinter } from "~/hooks/use-printer";
import { usePrinterManager } from "~/managers/use-printer-manager";

export const Route = createFileRoute(
  "/_main/settings/_layout/devices/printers",
)({
  component: Printers,
});

function Printers() {
  const { t } = useTranslation("common");
  const { printers } = usePrinter();
  const { openPrinterDialog } = usePrinterManager();
  const columns: ColumnDef<Printer>[] = [
    {
      id: t("name"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: printer }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html: highlightText(printer.name, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
    {
      id: t("Printer.connection_type"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Printer.connection_type")}
        />
      ),
      cell: ({ row: { original: printer }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html:
                highlightText(
                  t(`DeviceConnectionTypes.${printer.connectionType}`),
                  globalFilter,
                ) ?? "",
            }}
          ></p>
        );
      },
    },
  ];

  return (
    <>
      <SettingsHeader
        title={t("printers")}
        buttonLabel={capitalize(t("new_printer"))}
        buttonAction={async () => {
          await openPrinterDialog();
        }}
      />

      <DataTable
        columns={columns}
        data={printers}
        onSelect={openPrinterDialog}
      />
    </>
  );
}
